$(".js-header-toggle").click(function (e) {
	$("#subHeaderMenu").toggleClass("header__menu--open");
});
$(".js-secondary-menu-toggle").click(function (e) {
    $("#subHeaderSecondaryMenu").toggleClass("header__secondary-menu--open");
});